import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LoadingMaskService } from './_infrastructure/LoadingMask/LoadingMaskService';
import { SessionStorageService } from './_infrastructure/SessionStorageService/SessionStorageService';
import { CommonModule } from '@angular/common'

@Component({
  selector: 'validate-pgp-online',
  templateUrl: './validate-pgp-online.component.html',
  styleUrls: ['./validate-pgp-online.component.scss'],
  imports: [CommonModule]
})
export class ValidatePGPOnlineComponent implements OnInit {

  mensagemPrincipal: string ="Temporariamente indisponível. Por favor, tente mais tarde.";
  mensagemAdicional: string;
  showMessage: boolean = true;
  constructor(private http: HttpClient, private router: Router, private loadingMaskService: LoadingMaskService, private sessionStorageService: SessionStorageService) {

  }

  ngOnInit(): void {

    // PIT40802 \\

    this.loadingMaskService.setShowLoading(false);

    this.sessionStorageService.removeListaDePedidosOption();

    this.http.get<models.WorkflowStatusVM[]>('api/Workflow/ValidaDisponibilidadePGPCall').subscribe((result: any) => {

      if (result.stateCode == 'D') {
        // router Catálogo de Pedidos
        this.router.navigate(['workflowSearch']);
        return;
      }

      const messagem = result.message;
      const index = messagem.indexOf('.');
      this.showMessage = true;
      if (index !== -1) {
        this.mensagemPrincipal = result.message.slice(0, index + 1).trim();
        this.mensagemAdicional = result.message.slice(index + 1).trim();
      }
      else {
        this.mensagemPrincipal = result.message;
        this.mensagemAdicional = '';
      }      
      
    });
  }
}
